import React, { useRef, useState } from "react";
import DashboardTopBarAdmin from "../../components/admin/DashboardTopBarAdmin";
import PrimaryButton from "../../components/shared/PrimaryButton";
import SuccessButton from "../../components/shared/SuccessButton";
import ErrorButton from "../../components/shared/ErrorButton";
import Modal from "../../components/shared/Modal";
import LoadingIndicatorButton from "../../components/shared/LoadingIndicatorButton";

import discountsBlueIcon from "../../assets/admin/icons/discounts-blue.svg";
import plusIcon from "../../assets/admin/icons/plus-white.svg";

import DiscountCollectionFormAdmin from "../../components/admin/discount/DiscountCollectionFormAdmin";
import DiscountProductMenuFormAdmin from "../../components/admin/discount/DiscountProductMenuFormAdmin";
import DiscountWebshopFormAdmin from "../../components/admin/discount/DiscountWebshopFormAdmin";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchDiscounts, deleteDiscount } from "../../util/admin/httpAdmin";

import "./tab-styling.css";

function DiscountsAdmin() {
   const collectionModalRef = useRef();
   const productMenuModalRef = useRef();
   const webshopModalRef = useRef();
   const deleteModalRef = useRef();
   const [selectedDiscount, setSelectedDiscount] = useState(null);
   const [discountToDelete, setDiscountToDelete] = useState(null);
   const [activeTab, setActiveTab] = useState("productMenu");

   const queryClient = useQueryClient();

   const openCollectionModal = () => collectionModalRef.current.open();
   const openProductMenuModal = () => productMenuModalRef.current.open();
   const openWebshopModal = () => webshopModalRef.current.open();
   const closeModals = () => {
      collectionModalRef.current.close();
      productMenuModalRef.current.close();
      webshopModalRef.current.close();
      setTimeout(() => setSelectedDiscount(null), 500);
   };

   const openDeleteModal = (discount) => {
      setDiscountToDelete(discount);
      deleteModalRef.current.open();
   };

   const closeDeleteModal = () => {
      deleteModalRef.current.close();
      setDiscountToDelete(null);
   };

   const handleEditButtonClick = (discount) => {
      setSelectedDiscount(discount);
      if (discount.discountType === "Collection") {
         openCollectionModal();
      } else if (discount.discountType === "Webshop") {
         openWebshopModal();
      } else {
         openProductMenuModal();
      }
   };

   const { data, isPending, isError, error } = useQuery({
      queryKey: ["adminDiscounts"],
      queryFn: fetchDiscounts,
   });

   const deleteMutation = useMutation({
      mutationFn: deleteDiscount,
      onSuccess: () => {
         queryClient.invalidateQueries(["adminDiscounts"]);
         closeDeleteModal();
      },
   });

   return (
      <div>
         <DashboardTopBarAdmin
            title="Kortingen"
            icon={discountsBlueIcon}
            description="Hier kan je al jouw kortingen bekijken en bewerken"
         >
            <div className="flex-1">
               {/* <PrimaryButton onClick={() => {
                  setSelectedDiscount(null);
                  openCollectionModal();
               }}>
                  <div className="g-15-1fr">
                     <img src={plusIcon} alt="add" /> <span>Korting op collectie</span>
                  </div>
               </PrimaryButton> */}
               <PrimaryButton onClick={() => {
                  setSelectedDiscount(null);
                  openProductMenuModal();
               }}>
                  <div className="g-15-1fr">
                     <img src={plusIcon} alt="add" /> <span>Korting op producten/menus</span>
                  </div>
               </PrimaryButton>
               {/* <PrimaryButton onClick={() => {
                  setSelectedDiscount(null);
                  openWebshopModal();
               }}>
                  <div className="g-15-1fr">
                     <img src={plusIcon} alt="add" /> <span>Korting op hele assortiment</span>
                  </div>
               </PrimaryButton> */}
            </div>
         </DashboardTopBarAdmin>

         <div className="py-20 px-20 g-20">
            <div className="tabs">
               <button className={activeTab === "collection" ? "active" : ""} onClick={() => setActiveTab("collection")}>Collectiekortingen</button>
               <button className={activeTab === "productMenu" ? "active" : ""} onClick={() => setActiveTab("productMenu")}>Product/Menu Kortingen</button>
               <button className={activeTab === "webshop" ? "active" : ""} onClick={() => setActiveTab("webshop")}>Assortimentkortingen</button>
            </div>

            {isPending && <LoadingIndicatorButton dark />}
            {isError && <p className="c-r">{error?.message || "Er is iets foutgegaan"}</p>}

            {data && (
               activeTab === "collection" ? (
                  <div>
                     <div className="py-30 text-center">
                        <h2 className="mb-10">COMING SOON</h2>
                        <p>Collectiekortingen zullen binnenkort beschikbaar zijn!</p>
                     </div>
                  </div>
               ) : activeTab === "productMenu" ? (
                  <DiscountTable discounts={data.productMenuDiscounts} handleEditButtonClick={handleEditButtonClick} openDeleteModal={openDeleteModal} />
               ) : (
                  <div>
                     <div className="py-30 text-center">
                        <h2 className="mb-10">COMING SOON</h2>
                        <p>Kortingen op het hele assortiment zullen binnenkort beschikbaar zijn!</p>
                     </div>
                  </div>
               )
            )}
         </div>

         <Modal ref={collectionModalRef}>
            <DiscountCollectionFormAdmin key={selectedDiscount ? selectedDiscount._id : "new"} onSuccessClose={closeModals} editMode={!!selectedDiscount} previousData={selectedDiscount || {}} />
         </Modal>

         <Modal ref={productMenuModalRef}>
            <DiscountProductMenuFormAdmin key={selectedDiscount ? selectedDiscount._id : "new"} onSuccessClose={closeModals} editMode={!!selectedDiscount} previousData={selectedDiscount || {}} />
         </Modal>

         <Modal ref={webshopModalRef}>
            <DiscountWebshopFormAdmin key={selectedDiscount ? selectedDiscount._id : "new"} onSuccessClose={closeModals} editMode={!!selectedDiscount} previousData={selectedDiscount || {}} />
         </Modal>

         <Modal ref={deleteModalRef}>
            <div className="py-20 px-20 g-20">
               <h2>Bevestig Verwijderen</h2>
               <p>Weet je zeker dat je de korting van {discountToDelete?.discount}% wilt verwijderen?</p>
               <div className="flex-2">
                  <ErrorButton onClick={() => deleteMutation.mutate(discountToDelete._id)} disabled={deleteMutation.isLoading}>Verwijderen</ErrorButton>
                  <PrimaryButton className="secondary-button" onClick={closeDeleteModal}>Annuleren</PrimaryButton>
               </div>
            </div>
         </Modal>
      </div>
   );
}

const DiscountTable = ({ discounts, handleEditButtonClick, openDeleteModal }) => (
   discounts.length > 0 ? (
      <table className="tableSimpleStyling">
         <thead>
            <tr>
               <th>Betrekking op:</th>
               <th>Korting (%)</th>
               <th>Begindatum</th>
               <th>Einddatum</th>
               <th>Acties</th>
            </tr>
         </thead>
         <tbody>
            {discounts.map((discount) => (
               <tr key={discount._id}>
                  <td>
                     {discount.discountType === "Collection" ? 
                        `Collectie: ${discount.collection.name || discount.collection}` : 
                     discount.discountType === "Webshop" ?
                        `Hele assortiment: ${discount.description || "Korting op alle producten"}` :
                        `Specifieke items: ${[...(discount.products || []), ...(discount.menus || [])].map((item) => item.name).join(", ")}`
                     }
                  </td>
                  <td>{discount.discount}%</td>
                  <td>{new Date(discount.startDate).toLocaleDateString('nl-BE')}</td>
                  <td>{new Date(discount.endDate).toLocaleDateString('nl-BE')}</td>
                  <td>
                     <div className="flex-1">
                        <SuccessButton onClick={() => handleEditButtonClick(discount)}>
                           <span className="f-s">Bewerken</span>
                        </SuccessButton>
                        <ErrorButton onClick={() => openDeleteModal(discount)}>
                           <span className="f-s">Verwijderen</span>
                        </ErrorButton>
                     </div>
                  </td>
               </tr>
            ))}
         </tbody>
      </table>
   ) : (
      <p className="c-r">Geen kortingen beschikbaar.</p>
   )
);

export default DiscountsAdmin;
